import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { fieldsType } from "@/utils/types/field";
import fieldsDictionary from "../fieldsDictionary";
import { FieldViewType } from "../viewType";
import FileFieldDetail from "./detail";
import FileFieldEdit from "./edit";
import FileFieldList from "./list";
/** <b>Composant qui contient l'affichage d'un champ de type file en: </b>
 *  <li>Liste</li>
 *  <li>Détails</li>
 *  <li>Édition</li>
 */
export function File() {
    return _jsx(_Fragment, { children: "FILE" });
}
var field = fieldsType.file;
fieldsDictionary.registerField(FieldViewType.DETAIL, field, FileFieldDetail);
fieldsDictionary.registerField(FieldViewType.EDIT, field, FileFieldEdit);
fieldsDictionary.registerField(FieldViewType.LIST, field, FileFieldList);
